import React, {useEffect} from "react";
import useStateType from "../Stores/StateStore";

interface StateProps {
  displayValue?: number;
  id?: string;
}

const StateMenu: React.FC<StateProps> = ({displayValue, id}): JSX.Element => {
  const stateValue = useStateType((state) => state.stateValue);
  const setStateValue = useStateType((state) => state.setStateValue);
  const stateList = useStateType((state) => state.stateList);

  useEffect(() => {}, [displayValue]);

  return (
    <select
      id={id}
      className="w-[50px] truncate lg:w-auto text-start lg:text-center pl-1 pr-4 xl:select xl:select-bordered text-[12px] bg-[#E5DCDD] appearance-none focus:outline-none focus:ring-0 focus:border-transparent"
      defaultValue={stateValue}
      onChange={(event) => setStateValue(event.target.value)}>
      {stateList.map((label, index) => (
             <option className="flex items-center justify-center text-center"key={index} value={label}>

          {label}
        </option>
      ))}
    </select>
  );
};

export default StateMenu;
